module.exports = __webpack_public_path__ + "img/fan_backward.fc0c28cc.svg";